<template>
  <section v-if="records > pageSize">
    <div
      aria-label="navigate between pages"
      class="d-flex justify-content-between align-items-center"
    >
      <button
        class="btn btn-secondary-light my-auto px-4"
        :disabled="page == 1"
        @click="goToPrevPage()"
      >
        <i class="fa fa-chevron-left"></i>
      </button>

      <span>
        <div class="text-sm text-bold my-auto">
          Page {{ page }} of {{ pages }}
        </div>
      </span>
      <button
        class="btn btn-secondary-light my-auto px-4"
        :disabled="page == pages"
        :class="{ 'text-muted': page == pages }"
        @click="goToNextPage()"
      >
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    records: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  emits: ["update-page-selection"],
  data() {
    return {
      currentPage: this.page,
    };
  },
  computed: {
    pages() {
      if (this.records <= this.pageSize) return 1;

      if (this.records % this.pageSize > 0) {
        return Math.floor(this.records / this.pageSize) + 1; // has residual on last page
      } else return this.records / this.pageSize; // exact page size per page
    },
    pageRecords() {
      // number of records per page
      let maxRecords = this.page * this.pageSize;
      return maxRecords >= this.records ? this.records : maxRecords;
    },
  },
  watch: {
    page(newValue) {
      this.currentPage = newValue;
    },
  },
  methods: {
    goToPrevPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.$emit("update-page-selection", this.currentPage);
      }
    },
    goToNextPage() {
      if (this.currentPage < this.pages) {
        this.currentPage += 1;
        this.$emit("update-page-selection", this.currentPage);
      }
    },
  },
};
</script>

<style scoped></style>
